import React from 'react'
import { AuthApi } from 'src/api/authApi'
import { authenticatedUserStore, notifierStore } from 'src/stores'
import { Link } from 'react-router-dom'
import {
    Button,
    Drawer,
    Grid,
    Icon,
    Pagination,
} from '@softwaredev_cegeka/stix-core'
import { ServiceTable } from 'src/components/EntityTable'
import ServiceDrawerContent from 'src/components/Drawer/ServiceDrawerContent'
import DrawerHeader from '../components/Drawer/DrawerHeader'

class ServiceRoute extends React.Component {
    state = {
        services: [],
        page: 1,
        totalPages: 1,
        totalElements: 1,
        loading: false,
        selectedService: null,
        selectedServiceActions: [],
        params: {},
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidMount() {
        this.fetchAndStoreServices()
    }

    // Cancel still ongoing get requests, to prevent updating state and changing the page to the previous clicked link
    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    fetchAndStoreServices = (page = this.state.page) => {
        this.setState(
            {
                loading: true,
            },
            () => {
                this.authClient
                    .fetchServices(
                        page,
                        this.props.history,
                        this.state.params,
                        authenticatedUserStore.selectedOrganization?.id
                    )
                    .then(response => {
                        this.setState({
                            services: response?.data?.results,
                            totalPages: response?.data?._page.total_pages,
                            totalElements: response?.data?._page.total_elements,
                            loading: false,
                            page: page,
                        })
                    })
                    .catch(err => console.error(err))
            }
        )
    }

    handlePageChange = page => {
        this.setState({ page: page }, () => this.fetchAndStoreServices())
    }

    setParams = params => {
        this.setState(
            {
                params: params,
            },
            () => this.fetchAndStoreServices(1)
        )
    }

    removeService = (serviceId, serviceName) => {
        this.authClient
            .deleteService(serviceId)
            .then(response => {
                if (response.status === 200 || response.status === 204) {
                    this.fetchAndStoreServices()
                    notifierStore.setToastInfo(
                        `Service ${serviceName} successfully deleted`,
                        true
                    )
                } else {
                    notifierStore.setToastInfo(
                        'Failed to remove service ' + serviceName,
                        false
                    )
                }
            })
            .catch(err => {
                notifierStore.setToastInfo(
                    err.response?.data?.error ||
                        'Failed to remove service ' + serviceName,
                    false
                )
            })
            .finally(notifierStore.setShowMessage(true))
    }

    removeServiceAction = (serviceId, serviceActionId, serviceName) => {
        this.authClient
            .deleteServiceAction(serviceId, serviceActionId)
            .then(response => {
                if (response.status === 200 || response.status === 204) {
                    this.fetchAndStoreServices()
                    notifierStore.setToastInfo(
                        `Service ${serviceId} successfully deleted`,
                        true
                    )
                } else {
                    notifierStore.setToastInfo(
                        'Failed to remove service action from ' + serviceName,
                        false
                    )
                }
            })
            .catch(err => {
                notifierStore.setToastInfo(
                    err.response?.data?.error ||
                        'Failed to remove service action from ' + serviceName,
                    false
                )
            })
            .finally(notifierStore.setShowMessage(true))
    }

    getSelectedService() {
        return this.state.services.find(service => {
            return service.id === this.state.selectedService
        })
    }

    rowSelectHandler = async (selectObj, setDrawerState) => {
        const { selectedRow } = selectObj

        this.setState(
            {
                selectedService: selectedRow.original.id,
            },
            () => setDrawerState(true)
        )
    }

    render() {
        const selectedService = this.getSelectedService() || {}
        return (
            <div className="entity-drawer">
                <Drawer
                    type="fixed"
                    panelTitle={
                        <DrawerHeader
                            path={'/service-form/' + selectedService.id}
                            title={selectedService.name}
                        />
                    }
                    panelContent={
                        <ServiceDrawerContent
                            {...this.props}
                            selectedService={selectedService}
                            removeServiceAction={this.removeServiceAction}
                        />
                    }
                >
                    <Grid.Container>
                        <div className={'page-header'}>
                            <h1 className={'content-title'}>
                                Services overview
                            </h1>
                            <Link
                                to={{
                                    pathname: '/service-form',
                                }}
                            >
                                <Button variant="secondary">
                                    <Icon icon="add" />
                                    <span>Create service</span>
                                </Button>
                            </Link>
                        </div>
                        <div className="data-table-container">
                            <Drawer.Context.Consumer>
                                {({ setDrawerState }) => (
                                    <ServiceTable
                                        data={this.state.services}
                                        loading={this.state.loading}
                                        params={this.state.params}
                                        setParams={this.setParams}
                                        deleteAction={(
                                            serviceId,
                                            serviceName
                                        ) =>
                                            this.removeService(
                                                serviceId,
                                                serviceName
                                            )
                                        }
                                        rowSelectHandler={selectObj =>
                                            this.rowSelectHandler(
                                                selectObj,
                                                setDrawerState
                                            )
                                        }
                                    />
                                )}
                            </Drawer.Context.Consumer>
                            {this.state.totalPages >= 2 && (
                                <div className="pagination-wrapper">
                                    <Pagination
                                        lastPage={this.state.totalPages}
                                        currentPage={this.state.page}
                                        onClick={
                                            this.state.loading
                                                ? () => {}
                                                : this.handlePageChange
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </Grid.Container>
                </Drawer>
            </div>
        )
    }
}

export default ServiceRoute
